import { query } from "./strapi";

export interface NewsletterData {
  title: string;
  text: string;
  buttonText: string;
  icon?: {
    url: string;
    formats?: {
      thumbnail?: { url: string };
      small?: { url: string };
      medium?: { url: string };
      large?: { url: string };
    };
  };
}

/**
 * Fetches newsletter data from the API
 * @returns Promise with newsletter data
 */
export async function getNewsletter(): Promise<NewsletterData> {
  return query("newsletter-component")
    .then((res) => {
      if (!res) {
        throw new Error("Newsletter data not found");
      }
      return {
        title: res.title,
        text: res.text,
        buttonText: res.buttonText,
        icon: res.icon,
      };
    })
    .catch((err) => {
      console.error("Error fetching newsletter data:", err);
      // Return default values if API request fails
      return {
        title: "Subscribe to our newsletter",
        text: "Stay updated with our latest products and offers",
        buttonText: "Subscribe",
      };
    });
}
